import { getGametypeOrder } from '@/helpers/constants'
import { SNK } from '@/helpers/helpers'

// import tier_mix from '@/mixins/tier_mix'
// mixins: [tier_mix],

const tier_mix = {
  computed: {
    user_info() {
      return this.$store.getters.user_info
    },
    affiliateName() {
      return this.$store.getters.user_info.affiliate_name
    },
    subs() {
      const res = this.user_info.subs || []
      return res
    },
    allSubs() {
      let res = JSON.parse(JSON.stringify(this.user_info.subs || []))
      const order = getGametypeOrder()
      res = res.sort((a, b) =>
        order.indexOf(a.plan?.type.toLowerCase()) < order.indexOf(b.plan?.type.toLowerCase())
          ? -1
          : 1,
      )
      return res
    },
    purchasedSubs() {
      const res = this.allSubs.filter(sub => sub?.plan?.type?.toLowerCase() !== 'any')
      return res
    },
    purchasedSubsNoCancel() {
      let res = this.purchasedSubs.filter(i => !i.canceled)
      const order = getGametypeOrder()
      res = res.sort((a, b) =>
        order.indexOf(a.plan?.type.toLowerCase()) < order.indexOf(b.plan?.type.toLowerCase())
          ? -1
          : 1,
      )
      return res
    },
    notPurchasedTypes() {
      const all = [
        'cash',
        // 'straddle_ante_cash', not accessible in free tier !!!
        'mtt',
        'spins',
        'husng',
        // 'SHORTDECK',
      ]
      const purchased = this.subs.map(sub => sub.plan.type.toLowerCase())
      const res = all.filter(type => !purchased.includes(type))
      return res
    },
    // TODO Vue3
    // [Vue warn]: Property "namespace" was accessed during render but is not defined on instance.
    // will be fixed when we rewrite it to composable
    // https://vuejs.org/guide/reusability/composables.html#vs-mixins
    gameformat() {
      const res = this.$store.getters[SNK('gameformat', this.namespace)]
      return res
    },
    tm_accessInPremiumSubOnly() {
      return !this.gameformat.subscription_tier
    },
    nadaPurchased() {
      const res = this.purchasedSubs.some(
        i =>
          i.plan.tier.toLowerCase() === 'elite' ||
          i.plan.tier.toLowerCase() === 'premium' ||
          i.plan.tier.toLowerCase() === 'starter',
      )
      return !res
    },
    anyPremiumTierPurchased() {
      const res = this.purchasedSubs.some(i => i.plan.tier.toLowerCase() === 'premium')
      return res
    },
    starterPurchasedForCurrentGametypeGroup() {
      const { gameformats } = this.$store.getters
      const res = gameformats.some(
        i => i.group === this.gameformat?.group && i.subscription_tier === 'STARTER',
      )
      return res
    },
    gameformatFree() {
      return !this.gameformatTrial && !this.gameformatPurchased
    },
    gameformatTrial() {
      return this.gameformat?.subscription_tier === 'TRIAL'
    },
    gameformatStarter() {
      return this.gameformat?.subscription_tier === 'STARTER'
    },
    gameformatPremium() {
      return this.gameformat?.subscription_tier === 'PREMIUM'
    },
    gameformatElite() {
      return this.gameformat?.subscription_tier === 'ELITE'
    },
    gameformatPurchased() {
      return this.gameformatStarter || this.gameformatPremium || this.gameformatElite
    },
    gameformatSubscribed() {
      return this.gameformat?.is_subscribed
    },
    gameformatAny() {
      const res = this.allSubs.some(i => i.plan?.tier?.toLowerCase() === 'any')
      return res
    },
  },
}

export default tier_mix
